import React, { memo } from 'react';

import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { Button, DropdownMenu, DropdownMenuItem } from '@bringg/react-components';
import { Language as LanguageType } from '@bringg/types';

import overlayStyle from './add-language-dropdown.module.scss';

const DEFAULT_ADD_LANGUAGE_ARIA_LABEL = 'Add language';

export interface AddLanguageDropDownProps {
	languages: LanguageType[];
	onSelect: (lang: LanguageType) => void;
	addButtonAriaLabel?: string;
	['data-test-id']?: string;
}

const AddLanguageDropDownComponent = ({
	languages,
	onSelect,
	addButtonAriaLabel = DEFAULT_ADD_LANGUAGE_ARIA_LABEL,
	'data-test-id': dataTestId
}: AddLanguageDropDownProps) => {
	const items: DropdownMenuItem[] = languages.map(lang => ({
		key: lang.code,
		label: lang.name,
		onClick: () => onSelect(lang)
	}));

	return (
		<DropdownMenu items={items} trigger={['click']} overlayClassName={overlayStyle.overlay}>
			<Button
				shape="circle"
				type="link"
				size="large"
				aria-label={addButtonAriaLabel}
				icon={<BringgIcon iconName={BringgFontIcons.Plus} />}
				data-test-id={dataTestId}
			/>
		</DropdownMenu>
	);
};

export const AddLanguageDropDown = memo(AddLanguageDropDownComponent);
